import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sscWuxingZuxuan'
})
export class SscWuxingZuxuanPipe implements PipeTransform {

  transform(value: any): any {
    let lottery_arr = [];
    value.forEach((element) => {
      lottery_arr.push(element);
    });
    // 组选形态
    let form: string;
    let max_repeat = 0;
    let arr = Array.from(new Set(lottery_arr));

    switch (arr.length) {
      case 5:
        form = '120';
        break;
      case 4:
        form = '60';
        break;
      case 3:
        for (let i = 0; i < arr.length; i++) {
          let n = 0;
          value.forEach(element => {
            if (element === arr[i]) {
              n += 1;
              if (max_repeat < n) {
                max_repeat = n;
              }
            }
          });
        }

        if (max_repeat === 2) {
          form = '30';
        }

        if (max_repeat === 3) {
          form = '20';
        }
        break;
      case 2:
        for (let i = 0; i < arr.length; i++) {
          let n = 0;
          value.forEach(element => {
            if (element === arr[i]) {
              n += 1;
              if (max_repeat < n) {
                max_repeat = n;
              }
            }
          });
        }

        if (max_repeat === 3) {
          form = '10';
        }

        if (max_repeat === 4) {
          form = '5';
        }
        break;
      default: break;
    }

    return form;
  }

}
